import React from 'react';
import { StarIcon } from 'lucide-react';
interface StarRatingProps {
  rating: number;
  size?: number;
  showNumber?: boolean;
}
export function StarRating({
  rating,
  size = 16,
  showNumber = false
}: StarRatingProps) {
  return <div className="flex items-center gap-1" data-id="element-116">
      {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} size={size} className={star <= rating ? 'fill-yellow-400 text-yellow-400' : 'text-slate-300'} data-id="element-117" />)}
      {showNumber && <span className="ml-1 text-sm text-slate-600 font-medium" data-id="element-118">
          {rating.toFixed(1)}
        </span>}
    </div>;
}